import { ServiceProduct } from '@app/services/ServiceProduct';
import { ECommerceProductInfo2 } from '../ServiceProduct/ServiceProduct';

export interface ECommerceProduct {
  id: number;
  part: number;
  quantity?: number;
}

export interface ECommercePromotion {
  creative_name: string;
  promotion_id: string;
  promotion_name?: string;
  items?: ECommerceProduct[];
}

export interface ECommerceAddShippingInfo {
  coupon?: string;
  shipping_tier: string;
  items?: ECommerceProduct[];
}

export interface ECommerceAddPaymentInfo {
  coupon?: string;
  payment_type: string;
  items?: ECommerceProduct[];
}

export interface ECommercePurchase {
  transaction_id: string;
  coupon?: string;
  shipping?: number;
  items?: ECommerceProduct[];
}

export interface UserInfo {
  lastName: string;
  firstName: string;
  middleName: string;
  email: string;
  mobilePhone: string;
}

class ServiceEcommerce2 {
  inCart = [];
  scenarioLabel = '';

  async selectPromotion(promotion: ECommercePromotion) {
    if (!window) {
      return;
    }

    const data = {
      ...promotion,
      items: promotion.items ? await this.info(promotion.items) : [],
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'select_promotion',
      ecommerce: data,
    });
  }

  async selectItem(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const data = {
      items: await this.info(items),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'select_item',
      ecommerce: data,
    });
  }

  async viewItem(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const data = {
      currency: 'RUB',
      items: await this.info(items),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer?.push({
      event: 'view_item',
      ecommerce: data,
    });
  }

  async fastOrderOpen(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const data = {
      items: await this.info(items),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'fastOrderOpen',
      ecommerce: data,
    });
  }

  async goToCartHead() {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'Button_Cart',
      selection: {
        scenario: 'Сценарий 1',
        button: 'Корзина Шапки',
      },
    };
    window.dataLayer.push(data);

    console.log('dataLayer.push', JSON.stringify(data));
  }

  async goToCartBurger() {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'Button_Cart',
      selection: {
        scenario: 'Сценарий 1',
        button: 'Гамбургер',
      },
    };
    window.dataLayer.push(data);

    console.log('dataLayer.push', JSON.stringify(data));
  }

  async goToCartFoot() {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'Button_Cart',
      selection: {
        scenario: 'Сценарий 1',
        button: 'Таббар',
      },
    };
    window.dataLayer.push(data);

    console.log('dataLayer.push', JSON.stringify(data));
  }

  async addToCart(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const infos = await this.info(items);
    const value = infos.reduce((p, v) => p + v.price * v.quantity, 0);
    const data = {
      value,
      currency: 'RUB',
      items: infos,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: data,
    });
  }

  async viewCart(items: ECommerceProduct[], value: number) {
    if (!window) {
      return;
    }

    const infos = await this.info(items);

    const data = {
      value,
      currency: 'RUB',
      items: infos,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'view_cart',
      ecommerce: data,
    });
  }

  async removeFromCart(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const infos = await this.info(items);
    const value = infos.reduce((p, v) => p + v.price * v.quantity, 0);
    const data = {
      value,
      currency: 'RUB',
      items: infos,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: data,
    });
  }

  async addToWishlist(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const infos = await this.info(items);
    const value = infos.reduce((p, v) => p + v.price * v.quantity, 0);
    const data = {
      value,
      currency: 'RUB',
      items: infos,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: data,
    });
  }

  async beginCheckout(items: ECommerceProduct[]) {
    if (!window) {
      return;
    }

    const infos = await this.info(items);
    const value = infos.reduce((p, v) => p + v.price * v.quantity, 0);
    const data = {
      value,
      currency: 'RUB',
      items: infos,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: data,
    });
  }

  async addShippingInfo(shippingInfo: ECommerceAddShippingInfo) {
    if (!window) {
      return;
    }

    const data = {
      ...shippingInfo,
      currency: 'RUB',
      items: await this.info(shippingInfo.items),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_shipping_info',
      ecommerce: data,
    });
  }

  async addPaymentInfo(paymentInfo: ECommerceAddPaymentInfo) {
    if (!window) {
      return;
    }

    const data = {
      ...paymentInfo,
      currency: 'RUB',
      items: await this.info(paymentInfo.items),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_payment_info',
      ecommerce: data,
    });
  }

  async purchase(purchase: ECommercePurchase) {
    if (!window) {
      return;
    }

    const data = {
      ...purchase,
      currency: 'RUB',
      affiliation: 'Online Store',
      items: await this.info(purchase.items),
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: data,
    });
  }

  async purchase1Click(purchase: ECommercePurchase) {
    if (!window) {
      return;
    }

    const data = {
      ...purchase,
      value: 0,
      currency: 'RUB',
      affiliation: 'Fast order',
      items: await this.info(purchase.items),
    };

    data.value = data.items.reduce((p, c) => {
      return p + c.price * c.quantity;
    }, 0);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'purchase_1click',
      ecommerce: data,
    });
  }

  async login() {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'login',
    });

    window.yaCounter17488885 && window.yaCounter17488885.reachGoal('pers_enter');
  }

  async user(userId: any) {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'userId',
      user_id: userId,
    });
  }

  async form(formId: string) {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'generate_lead',
      formID: formId,
    });

    if (formId === 'FormRecordPhone') {
      window.dataLayer.push({
        event: 'phone_callback',
      });
    }
  }

  async phoneCallback() {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'phone_callback',
    });
  }

  async subscribe() {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'news_subscribe',
    });
  }

  async settingsToggle() {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'settings_toggle',
    });
  }

  async outOfStock() {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'outStock',
    });
  }

  async promoClick(promotion: ECommercePromotion) {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'promoClick',
      promo: [
        {
          id: promotion.promotion_id,
          name: promotion.creative_name,
          erid: promotion.promotion_id,
        },
      ],
    });
  }

  async promoView(promotions: ECommercePromotion[]) {
    if (!window) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'promoView',
      promotions: promotions.map(promotion => ({
        id: promotion.promotion_id,
        name: promotion.creative_name,
        erid: promotion.promotion_id,
      })),
    });
  }

  async setScenario(label: string) {
    this.scenarioLabel = label;
    console.log('scenarioLabel', this.scenarioLabel);
  }

  async scenario(label: string) {
    if (!this.scenarioLabel) {
      return;
    }

    if (!label) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    const data = {
      event: 'Button_Cart',
      selection: {
        scenario: this.scenarioLabel,
        button: label,
      },
    };
    window.dataLayer.push(data);

    console.log('dataLayer.push', JSON.stringify(data));
  }

  private async info(items: ECommerceProduct[]): Promise<ECommerceProductInfo2[]> {
    if (!Array.isArray(items)) {
      return [];
    }

    if (items.length === 0) {
      return [];
    }

    const tuples = [];
    items.forEach(item => {
      const id = item.id;
      const part = item.part;
      tuples.push(id + '-' + part);
    });

    const result = await ServiceProduct.getProductsFromTuples(tuples, true);
    return result.map(x => {
      const item = items.find(y => y.id === x._id);
      if (item && item.quantity) {
        x.quantity = item.quantity;
      }

      delete x._id;
      return x;
    });
  }

  async abTestInitVariantAnalytics(variant: string): Promise<void> {
    try {
      if (window && !window?.dataLayer?.some(x => x.event === 'ABC')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'ABC', visual: variant });
      }
    } catch (error) {
      console.error(error);
    }
  }

  async abTestFilterAnalytics(selectionKey: string, value: string): Promise<void> {
    try {
      if (window) {
        window.dataLayer = window.dataLayer || [];
        const events = window.dataLayer.filter(x => x.event === 'Autection');
        const selectionValues = events[events.length - 1]?.selection || {};
        window.dataLayer.push({
          event: 'Autection',
          selection: {
            ...selectionValues,
            [selectionKey]: value,
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  }
}

const serviceEcommerce2Instance = new ServiceEcommerce2();

export default serviceEcommerce2Instance;
